import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
} from '../actionHelpers';

// authenticate BO/MO user
const AUTHENTICATE_SALES_ASSISTED_USER = 'AUTHENTICATE_SALES_ASSISTED_USER';
export const AUTHENTICATE_SALES_ASSISTED = createSubmitType(
  AUTHENTICATE_SALES_ASSISTED_USER,
);
export const AUTHENTICATE_SALES_ASSISTED_SUCCESS = createSuccessType(
  AUTHENTICATE_SALES_ASSISTED_USER,
);
export const AUTHENTICATE_SALES_ASSISTED_ERROR = createErrorType(
  AUTHENTICATE_SALES_ASSISTED_USER,
);
export const AUTHENTICATE_SALES_ASSISTED_LOADING = createLoadingType(
  AUTHENTICATE_SALES_ASSISTED_USER,
);

// fetch sales assisted applications DON'T USE IT RIGHT NOW

const SALES_ASSISTED_APPLICATIONS = 'SALES_ASSISTED_APPLICATIONS_SCOPE';
export const SALES_ASSISTED_APPLICATIONS_FETCH = createFetchType(
  SALES_ASSISTED_APPLICATIONS,
);
export const SALES_ASSISTED_APPLICATIONS_SUCCESS = createSuccessType(
  SALES_ASSISTED_APPLICATIONS,
);
export const SALES_ASSISTED_APPLICATIONS_ERROR = createErrorType(
  SALES_ASSISTED_APPLICATIONS,
);
export const SALES_ASSISTED_APPLICATIONS_LOADING = createLoadingType(
  SALES_ASSISTED_APPLICATIONS,
);

// invite

const SALES_ASSISTED_SEND_INVITE_USER_SCOPE =
  'SALES_ASSISTED_SEND_INVITE_USER_SCOPE';
export const SALES_ASSISTED_SEND_INVITE_USER = createSubmitType(
  SALES_ASSISTED_SEND_INVITE_USER_SCOPE,
);
export const SALES_ASSISTED_SEND_INVITE_USER_SUCCESS = createSuccessType(
  SALES_ASSISTED_SEND_INVITE_USER_SCOPE,
);
export const SALES_ASSISTED_SEND_INVITE_USER_ERROR = createErrorType(
  SALES_ASSISTED_SEND_INVITE_USER_SCOPE,
);
export const SALES_ASSISTED_SEND_INVITE_USER_LOADING = createLoadingType(
  SALES_ASSISTED_SEND_INVITE_USER_SCOPE,
);

const SALES_ASSISTED_GET_INVITE_USER_SCOPE =
  'SALES_ASSISTED_GET_INVITE_USER_SCOPE';
export const SALES_ASSISTED_GET_INVITE_USER = createFetchType(
  SALES_ASSISTED_GET_INVITE_USER_SCOPE,
);
export const SALES_ASSISTED_GET_INVITE_USER_SUCCESS = createSuccessType(
  SALES_ASSISTED_GET_INVITE_USER_SCOPE,
);
export const SALES_ASSISTED_GET_INVITE_USER_ERROR = createErrorType(
  SALES_ASSISTED_GET_INVITE_USER_SCOPE,
);
export const SALES_ASSISTED_GET_INVITE_USER_LOADING = createLoadingType(
  SALES_ASSISTED_GET_INVITE_USER_SCOPE,
);

// set password

const SALES_ASSISTED_SET_PASSWORD_SCOPE = 'SALES_ASSISTED_SET_PASSWORD_SCOPE';
export const SALES_ASSISTED_SET_PASSWORD = createSubmitType(
  SALES_ASSISTED_SET_PASSWORD_SCOPE,
);
export const SALES_ASSISTED_SET_PASSWORD_SUCCESS = createSuccessType(
  SALES_ASSISTED_SET_PASSWORD_SCOPE,
);
export const SALES_ASSISTED_SET_PASSWORD_ERROR = createErrorType(
  SALES_ASSISTED_SET_PASSWORD_SCOPE,
);
export const SALES_ASSISTED_SET_PASSWORD_LOADING = createLoadingType(
  SALES_ASSISTED_SET_PASSWORD_SCOPE,
);
